import { useDataProvider } from "react-admin";
import { Box, Typography, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { candidateRequests } from "api/candidateApi";

const RankingSummary = props => {
  const { specialityId, campaignRankingId } = props;

  const dataProvider = useDataProvider();
  const [summary, setSummary] = useState();

  useEffect(() => {
    const fetchSummary = async () => {
      var { data } = await dataProvider.getOne(
        candidateRequests.getCampaignRankingSummary(campaignRankingId, specialityId),
      );
      setSummary(data);
    };

    fetchSummary();
  }, [dataProvider, campaignRankingId, specialityId]);

  if (!summary) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="space-around"
      mt={2}
    >
      {["remainingToEnroll", "accepted", "enrolled"].map(category => (
        <Box
          key={category}
          textAlign="center"
        >
          <Typography variant="subtitle1">
            {category === "accepted"
              ? "Приети"
              : category === "enrolled"
                ? "Записани"
                : category === "remainingToEnroll"
                  ? "Остават"
                  : ""}
          </Typography>
          <Tooltip
            arrow
            title={
              <Box>
                <Typography variant="body2">Мъже: {summary[category]?.male}</Typography>
                <Typography variant="body2">Жени: {summary[category]?.female}</Typography>
                <Typography variant="body2">С преференции: {summary[category]?.priority}</Typography>
              </Box>
            }
          >
            <Box
              sx={{
                display: "inline-block",
                cursor: "pointer",
              }}
            >
              <Typography variant="h5">{summary[category]?.total}</Typography>
            </Box>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default RankingSummary;
